"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSponsors = void 0;

var _types = require("./types");

/**
 * Loads all the sponsors from RTDB
 */
var loadSponsors = function loadSponsors(enqueueSnackbar) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;
    dispatch({
      type: _types.SPONSORS_LOADING
    });
    return api.getSponsors().then(function (snapshot) {
      return dispatch({
        type: _types.SPONSORS_SUCCESS,
        payload: snapshot.val()
      });
    }).catch(function (error) {
      console.error(error);
      dispatch({
        type: _types.SPONSORS_ERROR,
        error: error
      });
    });
  };
};

exports.loadSponsors = loadSponsors;